export const frOffers = {
    // OFFERS
    'offer.operation.create.input.name': 'Saisissez ici le nom du plan de vente *',
    'offer.operation.create.input.code': 'Saisissez ici le code du plan de vente',
    'offer.engagement.create.input.name': "Saisissez ici le nom de l'engagement *",
    'offer.engagement.create.input.code': "Saisissez ici le code de l'engagement",

    'offer.operation.delete.dialog.title': 'Suppression du plan de vente',
    'offer.operation.delete.dialog.content':
        'Êtes-vous sûr de vouloir supprimer ce plan de vente ?',
    'offer.engagement.delete.dialog.title': "Suppression de l'engagement ",
    'offer.engagement.delete.dialog.content': 'Êtes-vous sûr de vouloir supprimer cet engagement ?',

    'offer.operation.clone.dialog.title': 'Copie du plan de vente',
    'offer.operation.clone.dialog.content': 'Voulez-vous créer une copie de ce Plan de Vente ?',
    'offer.engagement.clone.dialog.title': "Copie du plan de l'engagement",
    'offer.engagement.clone.dialog.content': 'Voulez-vous créer une copie de cette Engagement ?',

    'offer.details.tabs.informations.linkedOperationId.button.label':
        'Lier à un plan de vente (par référence):',
    'offer.details.tabs.informations.linkedCloneOperationId.button.label':
        'Lier à un plan de vente NF/NFF (par référence):',

    'offer.details.tabs.informations.linkedOperationId.modal.title': 'Lier à un plan de vente',
    'offer.details.tabs.informations.linkedCloneOperationId.modal.title':
        'Lier à un plan de vente de NF/NFF',
    'offer.details.tabs.informations.linkedOperationId.modal.input.hint':
        'Saisissez ici la référence du plan de vente concerné',

    'offer.details.tabs.informations.linkedOperationId.title': 'Plan de vente NF/NFF lié:',
    'offer.details.tabs.informations.linkedEngagements.title': 'Engagements(s) lié(s) :',
    'offer.details.tabs.informations.linkedEngagements.none': 'Aucun',

    'offer.details.tabs.informations.inputs.description.floatingLabel': 'Description',
    'offer.info.description': 'Saisissez ici la description',
    'offer.info.deliveryWeek.label': 'Semaine de livraison',
    'offer.info.deliveryWeek': 'Saisissez ici la semaine de livraison prévue',

    'offer.info.promoPricesEnablable': 'Demander la saisie du paramétrage prix promo ',

    // OFFER > PRODUCTS

    'offer.details.product.header.recommendations.title': 'Actions sur les Précos',
    'offer.details.product.header.products.title': 'Actions sur la liste des Produits',

    'offer.details.product.pdmp.tab.General': 'Général',
    'offer.details.product.pdmp.tab.Marketing': 'Marketing',
    'offer.details.product.pdmp.tab.Prices': 'Prix',
    'offer.details.product.pdmp.tab.Preconisations': 'Précos/quantités',

    'offer.details.tabs.details.productDialogMultiPrice.switch.seen_in_prospectus.label':
        'Produit présent dans le prospectus ?',
    'offer.product.dialog.multiPrice.product_highlighted_4x3.label':
        'Produit mis en avant en 4x3 ?',
    'offer.product.dialog.multiPrice.product_highlighted_80x120.label':
        'Produit mis en avant en 80x120 ?',

    'offer.details.tabs.details.productItemMultiPrice.quantity_recommendation':
        'Qté préconisé: {category1_quantity_recommendation} / {category2_quantity_recommendation} / {category3_quantity_recommendation} / {category4_quantity_recommendation}',

    'offer.product.dialog.multiPrice.category1_quantity_recommendation.label':
        'Préconisation Catégorie 1',
    'offer.product.dialog.multiPrice.category2_quantity_recommendation.label':
        'Préconisation Catégorie 2',
    'offer.product.dialog.multiPrice.category3_quantity_recommendation.label':
        'Préconisation Catégorie 3',
    'offer.product.dialog.multiPrice.category4_quantity_recommendation.label':
        'Préconisation Catégorie 4',

    'offer.product.dialog.multiPrice.quantity_minimum': 'Nombre minimum de produits',
    'offer.product.dialog.multiPrice.quantity_maximum': 'Nombre maximum de produits',
    'offer.details.tabs.details.productDialogMultiPrice.inputs.quantity_buy_by_multiple_of':
        'Commande par multiple de',

    'offer.product.dialog.multiPrice.category1_quantity_recommendation':
        'Nombre préconisé de produits',
    'offer.product.dialog.multiPrice.category2_quantity_recommendation':
        'Nombre préconisé de produits',
    'offer.product.dialog.multiPrice.category3_quantity_recommendation':
        'Nombre préconisé de produits',
    'offer.product.dialog.multiPrice.category4_quantity_recommendation':
        'Nombre préconisé de produits',

    // OFFER > NOTIFICATIONS
    'offer.operation.details.tabs.notifs.manualInfo':
        "Envoyer une notification de relance aux collaborateurs qui n'ont pas encore consulté le plan de vente",
    'offer.engagement.details.tabs.notifs.manualInfo':
        "Envoyer une notification de relance aux collaborateurs qui n'ont pas encore consulté l'engagement ",

    //TOAST ERRORS
    'toast.apiErrors.OFFER_MISSING_AUDIENCE':
        "Aucune audience n'est définie pour cet élément, il ne peut pas être publié",
    'toast.apiErrors.OFFER_PRODUCT_MISSING_PRICE':
        "Un des produits de cette offre n'a pas de prix défini, il ne peut pas être publié",
    'toast.apiErrors.OFFER_ALREADY_PUBLISHED': 'Cette offre est déjà publiée',
    'toast.apiErrors.OFFER_ALREADY_UNPUBLISHED':
        'Cette offre est déjà au statut publication annulée',
    'toast.apiErrors.OFFER_MISSING_END_DATE': "La date d'échéance doit être saisie",
    'toast.apiErrors.OFFER_MISSING_PRODUCT': "L'offre doit contenir au moins un produit",
};
